<template>
<div class="chapter">
<div class="inner_page">
<p class="header-toc">Contents</p>
<p class="toc" id="rpage_vi"><a href="#/Editor#page_vi">Editor’s Preface</a></p>
<p class="toc" id="rpage_xi"><a href="#/Foreword#page_xi">Foreword</a></p>
<p class="toc" id="rpage_1"><span href="#/Preface#page_1" title="Link target outside of Sample">Preface</span></p>
<p class="toc" id="rpage_2"><span href="#/chapter01#page_2" title="Link target outside of Sample">Chapter 0</span></p>
<p class="toc" id="rpage_49"><span href="#/chapter02#page_49" title="Link target outside of Sample">Chapter 1</span></p>
<p class="toc" id="rpage_71"><span href="#/chapter03#page_71" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc" id="rpage_83"><span href="#/chapter04#page_83" title="Link target outside of Sample">Chapter <img alt="" height="10" src="images/inf.jpg" width="13"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?2f1fd71a